<nav>
	<ul>
		<li *ngFor="let node of nodes">
			<a [routerLink]="node.path" [routerLinkActive]="node.activeClass">
				{{ node.display }}
			</a>
			<ul *ngIf="node.children">
				<li *ngFor="let child of node.children">
					<a [routerLink]="child.path" [routerLinkActive]="child.activeClass">
						{{ child.display }}
					</a>
				</li>
			</ul>
		</li>
	</ul>
</nav>
